import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { batch, useComputed, useSignal } from "@preact/signals";
import Button from "../Button";
import DropDownMenu from "../DropDownMenu";
import Icon from "../Icon";
import MessageBox from "../MessageBox";
import layout from "../Layout/style.module.scss";
import style from "./style.module.scss";
export default function RumSnippet() {
    const config = window.SPEEDCURVE_RUM_SNIPPET;
    const variant = useSignal("compat");
    const copied = useSignal(false);
    const snippetCode = useComputed(() => {
        if (variant.value === "es2015") {
            return [
                `<script>${config.rumSnippetES2015}</script>`,
                `<script ${config.rumScriptAttributesES2015}></script>`,
            ].join("\n");
        }
        if (variant.value === "es2020") {
            return [
                `<script>${config.rumSnippetES2020}</script>`,
                `<script ${config.rumScriptAttributesES2020}></script>`,
            ].join("\n");
        }
        return [`<script>${config.rumSnippet}</script>`, `<script ${config.rumScriptAttributes}></script>`].join("\n");
    });
    if (!config) {
        console.error("RUM snippet information not found.");
        return null;
    }
    const helpUrl = config.rumHelpUrl;
    const spaHelpUrl = config.rumSpaHelpUrl;
    function copySnippet() {
        navigator.clipboard.writeText(snippetCode.value);
        copied.value = true;
    }
    function setVariant(value) {
        batch(() => {
            variant.value = value;
            copied.value = false;
        });
    }
    return (_jsxs(_Fragment, { children: [_jsxs("p", { children: ["Add the JavaScript snippet below to the ", _jsx("code", { children: "<head>" }), " of your pages to install SpeedCurve RUM, and read our ", _jsx("a", { href: helpUrl, children: "Getting Started Guide" }), ". Installing RUM onto a single-page application (SPA)? Read our ", _jsx("a", { href: spaHelpUrl, children: "SPA Guide" }), "."] }), _jsxs("div", { className: layout["flex"], style: { alignItems: "flex-start" }, children: [_jsx(DropDownMenu, { buttonPrefix: "Snippet Variant: ", displayType: "title-carrot-pill", onChange: (value) => setVariant(value.value), sections: [
                            {
                                options: [
                                    { label: "Most Compatible (Default)", value: "compat" },
                                    { label: "Modern Browsers (ES2015)", value: "es2015" },
                                    { label: "Cutting Edge (ES2020)", value: "es2020" },
                                ],
                            },
                        ], selected: variant.value }), _jsx("small", { children: _jsxs("a", { href: "https://support.speedcurve.com/docs/which-rum-snippet-variant-is-right-for-me", className: classNames(layout["flex"], layout["margin-left"], style["variant-help-link"]), target: "_blank", rel: "noreferrer", style: { alignItems: "center" }, children: [_jsx(Icon, { name: "help" }), " Which variant is right for me?"] }) })] }), _jsx("textarea", { className: style["rum-snippet-textarea"], value: snippetCode.value, readOnly: true, rows: 2 }), _jsx(Button, { type: "button", className: layout["margin-top-1/2"], variation: "primary", onClick: copySnippet, children: "Copy to clipboard" }), copied.value ? _jsx(MessageBox, { type: "success", children: "Code successfully copied to clipboard" }) : null] }));
}
